import Vue from 'vue';

var SCREEN_SIZES = {
  xs: {
    min: 0,
    max: 767
  },
  sm: {
    min: 768,
    max: 991
  },
  md: {
    min: 992,
    max: 1199
  },
  lg: {
    min: 1200,
    max: Infinity
  }
};

export var responsiveHelper = new Vue({
  data: {
    get SCREEN_SIZE() {
      return {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4
      };
    },
    currentScreenSize: null
  },
  created: function() {
    var self = this;

    self.matchScreenSize = function matchScreenSize() {
      var width = window.innerWidth;

      for (var size in SCREEN_SIZES) {
        if (SCREEN_SIZES.hasOwnProperty(size)) {
          if (width >= SCREEN_SIZES[size].min && width <= SCREEN_SIZES[size].max) {
            return self.SCREEN_SIZE[size];
          }
        }
      }
    };

    self.currentScreenSize = self.matchScreenSize();

    window.addEventListener("resize", function() {
      var newScreenSize = self.matchScreenSize();

      if (newScreenSize !== self.currentScreenSize) {
        self.$emit("screenSizeChange", newScreenSize, self.currentScreenSize, false);
        self.currentScreenSize = newScreenSize;
      } else if (newScreenSize === self.SCREEN_SIZE.xs) {
        self.$emit("screenSizeChange", newScreenSize, self.currentScreenSize, true);
      }
    });
  },
  methods: {
    getScreenSize: function() {
      return this.currentScreenSize;
    },
    isMobileDevice: function() {
      return (
        (typeof window.orientation !== "undefined" ||
          navigator.userAgent.indexOf("IEMobile") !== -1) &&
        this.getScreenSize() < 2
      );
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/login/utils/responsive-helper.js